import { render, staticRenderFns } from "./UserDetailField.vue?vue&type=template&id=35d68940&"
import script from "./UserDetailField.ts?vue&type=script&lang=ts&"
export * from "./UserDetailField.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports